import React from 'react'
import { useSelector } from 'react-redux'

import { hasPermission } from 'Selectors/users'
import { getAccountDetails, getAccountFeatures } from 'Selectors/account'

const UnAuthorizedComponent = () => {
  return (
    <div className='unauthorized h3 d-flex align-items-center justify-content-center h-100 w-100'>
      You don't have access to this Page
    </div>
  )
}

const Authorize = (WrappedComponent, requiredPermission) => {
  const WithAuthorization = (props) => {
    const canAcesss = useSelector((state) => hasPermission(state, requiredPermission))

    if (!canAcesss) {
      return <UnAuthorizedComponent />
    }

    return <WrappedComponent {...props} />
  }

  return WithAuthorization
}

export const AuthorizeFeature = (WrappedComponent, featureName, defaultEnabled) => {
  const WithAuthorization = (props) => {
    const accountDetails = useSelector(getAccountDetails)
    const accountFeatures = useSelector(getAccountFeatures)

    let canAcesss = accountFeatures[featureName]
    const insightSettings = accountDetails?.insight_settings ?? {}

    if (defaultEnabled) {
      canAcesss = accountFeatures[featureName] ?? defaultEnabled

      if (['knowledgeBase', 'training'].includes(featureName) && canAcesss) {
        canAcesss = Object.keys(insightSettings).length !== 0
      }
    }

    if (!canAcesss) {
      return <UnAuthorizedComponent />
    }

    return <WrappedComponent {...props} />
  }

  return WithAuthorization
}

export default Authorize
